module.exports = __webpack_public_path__ + "img/AT0000002568382.6286a3a7.png";